export * from "./downloadFile";
export * from "./product";
export * from "./header";
export * from "./sale";
export * from "./bonuses";

export const makeid = length => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const COMMENT_TYPE = {
  COMMENTS: 'comments',
  FEEDBACKS: 'feedbacks'
};

/**
 * Formats a price (in грн) for display. Free items (samplers/gifts) now cost
 * 0.01 грн (1 копійка) instead of 0, so kopecks must be preserved for
 * non-whole values; whole amounts stay without decimals as before.
 * @param {number} value
 * @returns {string}
 */
export const formatPrice = value => {
  const number = Math.round((Number(value) || 0) * 100) / 100;
  return Number.isInteger(number) ? String(number) : number.toFixed(2);
};

export const formatWholePrice = value => {
  const number = Number(value) || 0;
  return Math.abs(number) > 0 && Math.abs(number) < 1 ? formatPrice(number) : String(Math.round(number));
};

export const countComments = (comments, type) => {
  return comments.reduce((acc, item) => {
    let child = type === COMMENT_TYPE.COMMENTS ? item.comments : item.child;
    let childArray = child.data && child.data.length ? child.data : [];
    let childCounter = childArray.length ? countComments(childArray, type) : 0;
    return acc + 1 + childCounter;
  }, 0);
};
